import { MDBCol, MDBRow } from 'mdbreact'
import React from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import CustomDatatable from '../shared/datatables/DataTable'

const ListAgednda:React.FC = () => {
    const { user } = useSelector((state: RootState) => state.auth);
    return (
        <div>
            <MDBRow>
                <MDBCol md="9" className="offset-2" >
                    <CustomDatatable props={{ adminRole: user?.adminRole?.info, type: 'agenda' }} />
                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default ListAgednda
